import React from "react";
import { useQuery } from "@apollo/react-hooks";

import IconCollectionsSection from "./IconCollectionsSection";
import IconsSection from "./IconsSection";

import { SubpageContainer } from "./styles";

import { GET_PUBLISHED_ICON_DATA, GET_COLLECTION_DATA } from "./queries";

export const NUMBER_OF_ICONS_IN_GRID = 20;
export const TOTAL_DISPLAYED_COLLECTIONS = 6;

const CreatorProfileIconsPage = ({ username }) => {
    const {
        data: iconData = { icons: { items: [], totalCount: 0 } },
        loading: loadingIcons
    } = useQuery(GET_PUBLISHED_ICON_DATA, {
        variables: {
            username,
            limit: NUMBER_OF_ICONS_IN_GRID
        }
    });

    const { items: icons, totalCount: totalIconCount } = iconData.icons;

    const {
        data: collectionData = { collections: { items: [], totalCount: 0 } }
    } = useQuery(GET_COLLECTION_DATA, {
        variables: {
            username,
            limit: TOTAL_DISPLAYED_COLLECTIONS
        }
    });

    const {
        items: collections,
        totalCount: totalCollectionCount
    } = collectionData.collections;

    return (
        <SubpageContainer data-testid="creator-profile-icons-page">
            <IconsSection
                loading={loadingIcons}
                icons={icons}
                totalCount={totalIconCount}
                username={username}
            />
            <IconCollectionsSection
                totalCount={totalCollectionCount}
                username={username}
                collections={collections}
            />
        </SubpageContainer>
    );
};

export default CreatorProfileIconsPage;
